// context/CartContext.js
"use client";
import { createContext, useContext, useState, useEffect } from "react";
import { fetchDataFromApi } from "@/utils/api";

const CatContext = createContext();

const CatProvider = ({ children }) => {
  const [catData, setCatData] = useState();

  useEffect(() => {
    fetchDataFromApi("/api/category/getCategories", false).then((response) => {
      if (!response.error) {
        setCatData(response?.data);
      }
    });
  }, []);

  return (
    <CatContext.Provider value={{ catData, setCatData }}>
      {children}
    </CatContext.Provider>
  );
};

export { CatProvider };

export const useCat = () => useContext(CatContext);
